<template>
    <div class="move">
        <div class="home_header">
            <Swipe
                :loop="false"
                :show-indicators="false"
                width="100%"
                height="100%"
                :touchable="false"
                ref="swipeItem"
            >
                <SwipeItem v-for="(item,index) in tabs" :key="index">
                <VanImage :src="item.imgurl" fit="cover" width="100%" height="100%">
                    <template v-slot:loading>
                    <loading type="spinner" size="20" />
                    </template>
                    <template v-slot:error>加载失败</template>
                </VanImage>
                </SwipeItem>
            </Swipe>
        </div>
        <div class="main">
            <div class="tabs">
                <div v-for="(item,index) in tabs" :class="['tab', tabs.length==2?'tab2':'']" :key="index" @click="itemChange(item,index)">
                    <img :src="active==index?item.aclist[1]:item.aclist[0]">
                </div>
            </div>
            
            <div class="body" :style="{background:item.id==462?'#FD8C87':item.id==463?'#F69C57':'#67AFE0'}">
                <Type :item="item" />
            </div>
        </div>
    </div>
</template>

<script>
import { Image, Loading, Tab, Tabs, Swipe, SwipeItem } from "vant";
import Type from "./component/type";
import './index.less'
export default {
    components: {
        VanImage: Image,
        Loading,
        Tab,
        Tabs,
        Swipe,
        SwipeItem,
        Type
    },
    props: ["sports_id", "item_id"],
    data() {
        return {
            active: 0,
            tabs: [],
            detail: "",
            item: {}
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
        });
    },
    methods: {
        itemChange: function (item,index) {
            this.active = index
            this.item = item
            this.$router.replace({params:{item_id:item.id}})
        },
        init() {
            this.$toast.loading({
                message: "加载中...",
                forbidClick: true,
                duration: 0, // 持续展示 toast
            });
            this.$api.sports.sportsMain(this.sports_id).then(
                (res) => {
                    res.data.items.forEach(item=>{
                        item.aclist = JSON.parse(item.content)
                    })
                    this.tabs = res.data.items;

                    this.active = res.data.items.findIndex(ele=> ele.id == this.item_id)
                    if(this.active == -1) {
                        this.$toast.fail("活动有误")
                        return
                    }
                    this.item = res.data.items[this.active]
                    let {
                        id,
                        title,
                    } = res.data;
                    this.detail = { id, title };
                    //定义 颜色
                    this.$toast.clear();
                    if (window.__wxjs_is_wkwebview) {
                        //部分ios
                        window.scrollTo(0, 1);
                    }
                    
                },
                (e) => {
                    this.$toast.clear();
                }
            );
        }
    }
}
</script>